define('SageDotCom/Components/PartnerSearchMap',["jquery",
        "eventManager"],
    function ($, eventManager) {
        function PartnerSearchMap(showStreetViewControl, initialZoomLevel, mapTypeControl, fullScreenControl) {
            var map = null;
            var infoWindowMarker;
            var markers = [];

            eventManager.subscribe("partner-search-map-triggered", function (partners, location, mapIsNotTriggeredFromShowToggle) {
                if (partners.length === 0) {
                    $('#gmap').html('');
                    map = null;
                    return;
                }
                var centerLocation = (location.latitude == '' || location.longitude == '') ? location : getClosestPartnerLocationIfCurrentLocationIsNotForwarded(partners);
                function getClosestPartnerLocationIfCurrentLocationIsNotForwarded(partners) {
                    // first partner is closest since they are sorted from closest to the furthest
                    return { lat: partners[0].latitude, lng: partners[0].longitude };
                }
                
                var zoomLevel = partners.length == 1 && !mapIsNotTriggeredFromShowToggle ? 14 : initialZoomLevel;

                if (map == null) {
                    createMap();
                    settingMapMarkers();

                } else if (mapIsNotTriggeredFromShowToggle) { // this updates map after applying filter or after hide toggle link
                    settingMapMarkers();
                    closeWindowMarker();
                    zoomMap(initialZoomLevel);
                    
                } else { // this updates map after clicking on show link for specific partner
                    var selectedMarker =  _.filter(markers,
                        function(marker) {
                            return marker.id == partners[0].id;
                        }
                    )[0];
                    zoomMap(zoomLevel);

                    selectedMarker.setMap(map);
                    addWindowMarker(selectedMarker);
                }

                function createMap() {
                    map = new google.maps.Map(document.getElementById('gmap'),
                        {
                            zoom: zoomLevel,
                            center: centerLocation,
                            streetViewControl: showStreetViewControl,
                            mapTypeControl: mapTypeControl,
                            fullscreenControl: fullScreenControl
                        }
                    );
                }

                function settingMapMarkers() {
                    removeMarkersFromMap();

                    for (var i = 0; i < partners.length; i++) {
                        var partnerPosition = {
                            lat: partners[i].latitude,
                            lng: partners[i].longitude
                        };

                        var marker = new google.maps.Marker({
                            position: partnerPosition,
                            title: partners[i].name,
                            content: '<p>' + partners[i].name + '</p> <p>' + partners[i].addressLine1 + '</p>',
                            map: map
                        });

                        markers.push(marker);
                        marker.set('id', partners[i].locId);

                        if (partners.length === 1 && !mapIsNotTriggeredFromShowToggle) {
                            zoomMap(this.position);
                        }
                        
                        setClickMarkerEvent(marker);
                    }
                }
                
                function addWindowMarker(selectedMarker) {
                    infoWindowMarker = new google.maps.InfoWindow({
                        content: selectedMarker.content
                    });

                    infoWindowMarker.open(map, selectedMarker);
                }

                function closeWindowMarker() {
                    if (infoWindowMarker) {
                        infoWindowMarker.close();
                    }
                }

                var setCenterTimeout = undefined;
                function zoomMap(zoomLevel) {
                    clearTimeout(setCenterTimeout);

                    map.setZoom(zoomLevel);
                    setCenterTimeout = setTimeout(function () {
                        map.setCenter(centerLocation);
                    }, 300);
                }

                function removeMarkersFromMap() {
                    for (var i = 0; i < markers.length; i++) {
                        markers[i].setMap(null);
                    }
                    markers = [];
                }
                
                function setClickMarkerEvent(marker) {
                    google.maps.event.addListener(marker, 'click', function () {
                        var locId = this.get("id");
                        eventManager.trigger("partner-search-pin-click-triggered", locId);

                        map.setZoom(14);
                        map.setCenter(this.position);
                        this.setMap(map);
                    });
                }
            });
        }

        PartnerSearchMap.init = function init(args) {
            return args.IsExperienceEditorEditing === false
                ? new PartnerSearchMap(
                    args.ShowStreetViewControl,
                    args.InitialZoomLevel,
                    args.MapTypeControl,
                    args.FullScreenControl)
                : null;
        };

        PartnerSearchMap.load = function (key, req, onLoad) {
            // load google deps with google key
            require(["https://maps.googleapis.com/maps/api/js?v=3.exp&sensor=false&key=" + key], function () {
                onLoad(PartnerSearchMap);
            });
        }

        return PartnerSearchMap;
    });
